<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Scheduling Reports</h4>
                    <ReportDownloader report-label="Tentative Schedule"
                                      endpoint="Wraparound/Reports/TeamReports/TentativeSchedule"
                                      :parameter-schema="ParamsTeamWeekStart"
                                      report-description="Generates a weekly tentative schedule for all of the current clients on this team for the week indicated (Sunday - Saturday).  Output is a word document." />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../../Core/UI/ReportDownloader.vue';
    export default {
        props: ["TeamRecordData"],
        data: function () {
            return {
                ParamsTeamWeekStart: [
                    {
                        Label: "Team:",
                        Name: "TeamID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Week Starting:",
                        Name: "WeekStartDate",
                        Type: "Date",
                        CustomDateConfig: {
                            dateFormat: 'Y-m-d',
                            allowInput: true,
                            altInput: true,
                            altFormat: 'm/d/Y',
                            required: false,
                            enable: [
                                function(date) {
                                    // return true to enable
                                    //enable only sundays
                                    return (date.getDay() === 0);

                                }
                            ]
                            //enable: ["2021-07-25", "2021-08-01", "2021-08-08", "2021-08-15", "2021-08-22", "2021-08-29", "2021-09-05", "2021-09-12", "2021-09-19", "2021-09-26", "2021-10-03", "2021-10-10"]
                        }
                    },
                ]
            };
        },
        methods: {

        },
        computed: {
        },
        components: {
            ReportDownloader
        },
        mounted() {
            this.ParamsTeamWeekStart[0].Value = this.TeamRecordData.Id
            this.ParamsTeamWeekStart[0].DisplayValue = this.TeamRecordData.Name;
        }
    }
</script>

<style scoped>
</style>